<template>
  <ProSpaceRightPanel
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="basetype" v-slot:center>
      <ProSpacePanelBlock :header="headerOverview">
        <template v-slot:header>
          <ProSpaceAction
            v-if="checkEditAccess(baseType)"
            :text="$t('editItemTxt')"
            @click="onClickEdit"
          />
        </template>
        <template v-slot>
          <ProSpacePanelBlockList :list="content" />
        </template>
      </ProSpacePanelBlock>
    </template>
    <template v-if="basetype" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
import { BaseTypeService } from "../../../services/BaseTypeService";
import { mapGetters } from "vuex";
import { useMultiSelectRightPanel } from "@composes/multiselect";
export default {
  name: "BaseTypePanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  setup() {
    const { selectedData } = useMultiSelectRightPanel();
    return {
      selectedData,
    };
  },
  data() {
    return {
      basetype: null,
      basetypeService: new BaseTypeService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerOverview() {
      return {
        title: this.$t("parameters"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    header() {
      if (this.basetype) {
        return {
          title: this.basetype.name,
          id: this.basetype.id,
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
    },
    content() {
      if (this.basetype) {
        return [
          [
            {
              title: this.$t("type"),
              text: this.basetype.name,
            },
          ],
          [
            {
              title: this.$t("description"),
              text: this.basetype.description,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      let metaInfo = [];
      if (this.basetype) {
        if (this.checkAccess("metainfo-by-block"))
          metaInfo.push([
            {
              title: this.$t("createdByTxt"),
              text: this.basetype.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.basetype.updatedBy,
            },
          ]);

        metaInfo.push([
          {
            title: this.$t("createdAtTxt"),
            text:
              this.getFormatDateTime(this.basetype.createdAt) +
              " " +
              getAMorPM(this.basetype.createdAt, this.userinfo.timeFormat),
          },
          {
            title: this.$t("lastUpdatedTxt"),
            text:
              this.getFormatDateTime(this.basetype.lastUpdated) +
              " " +
              getAMorPM(this.basetype.lastUpdated, this.userinfo.timeFormat),
          },
        ]);
      }
      return metaInfo;
    },
  },
  mounted() {
    this.update();
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots
        ? this.filterAccessDots(options, this.basetype)
        : options;
    },
    onClickEdit() {
      this.$emit("edit", this.basetype);
    },
    update() {
      this.hasError = false;
      try {
        this.getBaseType();
      } catch (e) {
        this.hasError = true;
      }
    },
    getBaseType() {
      if (this.selectedData) {
        this.loading = true;
        this.basetypeService.get(this.selectedData.id).then((res) => {
          this.basetype = res.data;
          this.loading = false;
        });
      }
      this.basetype = null;
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.basetype);
    },
    deletePanel() {
      this.$emit("delete", this.basetype);
    },
    showHistoryPanel() {
      this.$emit("history", this.basetype);
    },
  },
  watch: {
    selectedData: {
      handler() {
        this.update();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
